export default __webpack_public_path__ + "static/media/223.330f9b7e.jpg";